<template>
  <div class="content-wrappper reg-home">
    <regulatory-update-header
      :permissions="permissions"
      :headerValues="headerValues"
      :searchRegulatoryText="searchRegulatory"
      :isFromGlobalSearch="isFromGlobalSearch"
      @filterSearchRegulatory="filterSearchRegulatory"
    ></regulatory-update-header>
    <div class="body">
      <div class="regulatory-alert-updates p-relative">
        <shared-left-filter
          v-if="permissions.includes('REG_WTCH_REG_UPD_FILTER')"
          @setFilter="setFilterOptions"
          :chevronList="chevronList"
          :expectedFilter="resultingFilter"
          :countriesList="countriesList"
          :dateFormat="dateFormat"
          :permissions="permissions"
          :types="types"
          :isRegWatch="true"
        >
        </shared-left-filter>
        <!-- New Tabs will come here -->
        <div class="reg-update-tabs col-xs-12 p-0 xs-pt-15">
          <template>
            <ul class="horizontal-tabs d-flex p-0 mt-10">
              <li
                @click="setTab('new')"
                class="cursor-pointer"
                :class="{ active: activeName === 'new' }"
                v-if="permissions.includes('REG_WTCH_REG_UPD_NEW')"
              >
                New ({{ headerValues.newCount }})
              </li>
              <li
                @click="setTab('viewAll')"
                class="cursor-pointer"
                :class="{ active: activeName === 'viewAll' }"
                v-if="permissions.includes('REG_WTCH_REG_UPD_VIEW_ALL')"
              >
                View All ({{ headerValues.viewAllCount }})
              </li>
              <li
                @click="setTab('covid19')"
                class="cursor-pointer"
                :class="{ active: activeName === 'covid19' }"
                v-if="permissions.includes('REG_WTCH_REG_UPD_COVID_19')"
              >
                COVID-19 ({{ headerValues.covid19Count }})
              </li>
              <li
                @click="setTab('flag')"
                class="cursor-pointer"
                :class="{ active: activeName === 'flag' }"
                v-if="permissions.includes('REG_WTCH_REG_UPD_FLAGGED')"
              >
                Flagged ({{ headerValues.flaggedCount }})
              </li>
              <li
                @click="setTab('archive')"
                class="cursor-pointer"
                :class="{ active: activeName === 'archive' }"
                v-if="permissions.includes('REG_WTCH_REG_UPD_ARCHIVE')"
              >
                Archive ({{ headerValues.archiveCount }})
              </li>
            </ul>
          </template>
        </div>
        <!-- New Tabs will end here -->
        <regulatory-update-container
          :permissions="permissions"
          :filterCollapse="filterCollapse"
          :selectedMenu="selectedMenu"
          :regulatoryUpdateList="regulatoryUpdateList"
          @updateFlag="markRegUpdateAsFlagged"
          @deleteRegulatoryFromNew="deleteRegulatoryFromNew"
          @archiveRegulatory="archiveRegulatory"
          @unArchiveRegulatory="unArchiveRegulatory"
          :searchRegulatory="searchRegulatory"
          :isFromGlobalSearch="isFromGlobalSearch"
          :globalSearchFilteredData="globalSearchFilteredData"
        ></regulatory-update-container>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <unsubscribed-country-popup
      @setGlobalSearch="isFromGlobalSearch = false"
      @regWatchInAccountSettings="OpenRegWatchSettings"
      id="modal_unsubscribed_country"
      :isCountryNotSubscribed="true"
    ></unsubscribed-country-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import UnsubscribedCountryPopup from '../RegulatoryProcessCharts/UnsubscribedCountryPopup.vue';
import Loader from '../UIComponents/Loader.vue';
import RegulatoryUpdateHeader from './RegulatoryUpdateHeader.vue';
import RegulatoryUpdateContainer from './RegulatoryUpdateContainer.vue';
import SharedLeftFilter from '../UIComponents/SharedLeftFilter.vue';
import EventBus from '../../utils/event-bus';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

import {
  getPublishedRegulatoryAlerts,
  getUserProdRegistration,
  getCOVID19Keys,
  getRegulatoryWatchStatus,
  updateRegulatoryWatchStatus,
  getMatchedRecordsForGlobalSearch
} from '../../apis/regulatoryUpdate';
import { getRegWatchCountries } from '../../apis/countriesList';
import { getUserEmailAlertsPreferences } from '../../apis/profile';

export default {
  mixins: [permissionsList],
  components: {
    Loader,
    RegulatoryUpdateHeader,
    RegulatoryUpdateContainer,
    SharedLeftFilter,
    UnsubscribedCountryPopup
  },
  data() {
    const alertsDefaultData = {
      viewAll: [],
      new: [],
      flag: [],
      archive: [],
      covid19: []
    };
    return {
      activeName: '',
      chevronList: {
        isDateChevron: 'Posted Date',
        isEffectiveDateChevron: 'Effective Date',
        isCountryChevron: 'Country'
      },
      types: {
        label: 'regWatch',
        countryId: 'id',
        countryName: 'name'
      },
      dateFormat: 'YYYY-MM-DD',
      resultingFilter: {
        dateRange: {},
        effectiveDates: {},
        countriesList: [],
        isFilterSelected: false
      },
      countriesList: [],
      permissions: [],
      postedStartDate: '',
      postedEndDate: '',
      covid19KeysList: [], // covid19
      searchRegulatory: '',
      regulatoryFilterObj: { flags: {} },
      loaderStatus: false,
      filterCollapse: true,
      selectedMenu: 'new',
      initialCount: 0,
      filterInitialCounts: {
        serach: false,
        filter: false
      },
      headerValues: {
        newCount: 0,
        viewAllCount: 0,
        flaggedCount: 0,
        archiveCount: 0,
        covid19Count: 0 // covid19
      },
      regUpdatesIdList: {
        new: [],
        flag: [],
        archive: [],
        country_affected: []
      },
      publishedAlerts: [],
      productByCountry: [],
      regulatoryUpdatesListCopy: {},
      globalSearchFilteredData: {
        ...alertsDefaultData
      },
      isFromGlobalSearch: false,
      regulatoryUpdateList: {
        viewAll: [],
        new: [],
        flag: [],
        archive: [],
        covid19: [] // covid19
      }
    };
  },
  async created() {
    const { search, countryName, serviceId, service } = this.$route.params;
    this.loaderStatus = true;
    if (serviceId) {
      this.activeName = 'viewAll';
      await this.getMatchedDataForGlobalSearch(serviceId, service);
    }
    await this.getAllRegAlerts();
    await this.validateFeatures();
    this.setDefaultTabName(serviceId);
    if ((search || countryName) && serviceId) {
      if (countryName) {
        const selectedCountry = this.countriesList.find((country) => country.name === countryName);
        if (selectedCountry) EventBus.$emit('redirectionParams', { countryId: selectedCountry.id });
        else this.showUnsubscribedPopup();
      }
      if (!this.isFromGlobalSearch) this.searchRegulatory = search;
      // EventBus.$emit('redirectionParams', { countryId: selectedCountry.id });
    } else if (this.$route.params.countryName) {
      // from Registration Details
      if (this.permissions.includes('REG_WTCH_REG_UPD_COUNTRY_FILTER')) {
        EventBus.$emit('redirectionParams', { countryId: this.$route.params.countryId });
      }
    } else if (this.$route.params.notificationRegWatchFilter) {
      // from Notification Reg watch
      const params = this.$route.params.notificationRegWatchFilter;
      const filterKeys = {};
      if (this.permissions.includes('REG_WTCH_REG_UPD_COUNTRY_FILTER')) {
        filterKeys.countryId = params.countryId;
      }
      if (
        this.permissions.includes('REG_WTCH_REG_UPD_POSTED_DATE_FILTER') &&
        this.permissions.includes('REG_WTCH_REG_UPD_POSTED_DATE_RANGE')
      ) {
        filterKeys.startDate = params.startDate;
        filterKeys.endDate = params.endDate;
      }
      EventBus.$emit('redirectionParams', filterKeys);
    }
    this.loaderStatus = false;
  },
  methods: {
    OpenRegWatchSettings() {
      EventBus.$emit('notificationSettings', 'notifications');
    },
    showUnsubscribedPopup() {
      $('#modal_unsubscribed_country').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async getMatchedDataForGlobalSearch(serviceId, service) {
      const response = await getMatchedRecordsForGlobalSearch({
        id: +serviceId,
        service
      });
      this.setGlobalSearchResultData(response.reg_alerts);
      this.isFromGlobalSearch = true;
      // this.globalSearchFilteredData = response.reg_alerts || [];
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    setTab(tab) {
      if (this.isFromGlobalSearch) this.isFromGlobalSearch = false;
      this.activeName = tab;
      this.selectedMenu = this.activeName;
      if (Object.values(this.regulatoryFilterObj.flags).some((val) => val)) {
        this.filterRegUpdates(this.regulatoryFilterObj);
      }
    },

    /* to delete new regUpdates */
    async deleteRegulatoryFromNew(id) {
      const requestObj = {
        reg_watch_id: id,
        status: 'read'
      };
      this.loaderStatus = true;
      const response = await updateRegulatoryWatchStatus(requestObj);
      if (!response || !response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the status of Regulatory Update!',
          group: 'custom-notification'
        });
        return;
      }
      const indexForId = this.regUpdatesIdList.new.indexOf(id);
      this.regUpdatesIdList.new.splice(indexForId, 1);
      this.setDataAfterAnyAction();
      this.loaderStatus = false;
    },

    setDataAfterAnyAction() {
      const allAvailableRegUpdateIdsStatus = this.getIdsWithStatus();
      const currentList = this.setRegUpdatesData(
        this.publishedAlerts,
        allAvailableRegUpdateIdsStatus
      );
      this.regulatoryUpdatesListCopy = cloneDeep(currentList);
      this.setDataBasedOnSelectedConstraints(currentList);
    },

    setDataBasedOnSelectedConstraints(ref) {
      if (
        this.regulatoryFilterObj.flags.published_date_flag ||
        this.regulatoryFilterObj.flags.country ||
        this.regulatoryFilterObj.effective_date_flag
      ) {
        this.filterRegUpdates(this.regulatoryFilterObj, ref);
      } else {
        this.sortRegulatoryList(ref);
        this.setCountForTabs();
      }
    },

    /* to mark RegUpdate as flagged */
    async markRegUpdateAsFlagged(flag, id) {
      const requestObj = {
        reg_watch_id: id,
        status: flag ? 'flagged' : 'unflagged'
      };
      this.loaderStatus = true;
      const response = await updateRegulatoryWatchStatus(requestObj);
      this.loaderStatus = false;
      if (!response || !response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the status of Regulatory Update!',
          group: 'custom-notification'
        });
        return;
      }
      if (flag) {
        this.regUpdatesIdList.flag.push(id);
      } else {
        const indexForId = this.regUpdatesIdList.flag.indexOf(id);
        this.regUpdatesIdList.flag.splice(indexForId, 1);
      }
      this.setDataAfterAnyAction();
      this.loaderStatus = false;
    },

    /* to archive regUpdate */
    async archiveRegulatory(id) {
      const archiveRequestObj = {
        reg_watch_id: id,
        status: 'archive'
      };
      this.loaderStatus = true;
      const response = await updateRegulatoryWatchStatus(archiveRequestObj);
      if (!response || !response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the status of Regulatory Update!',
          group: 'custom-notification'
        });
        return;
      }
      this.regUpdatesIdList.archive.push(id);
      this.checkIsIdAvailableInOtherTabStatus(id);
      this.setDataAfterAnyAction();
      this.loaderStatus = false;
    },

    checkIsIdAvailableInOtherTabStatus(id) {
      Object.keys(this.regUpdatesIdList).forEach((key) => {
        if (key !== 'country_affected' && key !== 'archive') {
          const indexOfId = this.regUpdatesIdList[key].indexOf(id);
          if (indexOfId !== -1) {
            this.regUpdatesIdList[key].splice(indexOfId, 1);
          }
        }
      });
    },

    /* To unArchive regUpdate */
    async unArchiveRegulatory(id) {
      const archiveRegulatoryRequest = {
        reg_watch_id: id,
        status: 'unarchive'
      };
      this.loaderStatus = true;
      const response = await updateRegulatoryWatchStatus(archiveRegulatoryRequest);
      if (!response || !response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the status of Regulatory Update!',
          group: 'custom-notification'
        });
        return;
      }
      const indexForId = this.regUpdatesIdList.archive.indexOf(id);
      this.regUpdatesIdList.archive.splice(indexForId, 1);
      this.setDataAfterAnyAction();
      this.loaderStatus = false;
    },

    /* It will set countries list to  countriesList array */
    async getCountryList() {
      this.userPreferences = await getUserEmailAlertsPreferences();
      const countriesList = [];
      const countries = await getRegWatchCountries();
      countries.forEach((country) => {
        if (
          !this.userPreferences.sync_display ||
          (this.userPreferences.sync_display &&
            this.userPreferences.regulatory_email_notification_country_ids[0] === 'all')
        ) {
          countriesList.push({ id: country.id, name: country.country_name });
        } else if (
          this.userPreferences.default_country &&
          country.id === this.userPreferences.default_country
        ) {
          countriesList.push({ id: country.id, name: country.country_name });
        } else if (
          this.userPreferences.regulatory_email_notification_country_ids.includes(
            country.id.toString()
          )
        ) {
          countriesList.push({ id: country.id, name: country.country_name });
        }
      });
      this.countriesList = cloneDeep(countriesList);
      const result = this.countriesList.map((country) => country.name);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Regulatory watch countries',
        countryList: result
      });
    },

    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER', 'REGULATORY_WATCH'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REGULATORY_UPDATES'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },

    setDefaultTabName(serviceId) {
      if (serviceId && this.permissions.includes('REG_WTCH_REG_UPD_VIEW_ALL')) {
        this.activeName = 'viewAll';
        this.selectedMenu = this.activeName;
      } else if (this.permissions.length > 0) {
        if (this.permissions.includes('REG_WTCH_REG_UPD_NEW')) {
          this.activeName = 'new';
        } else if (this.permissions.includes('REG_WTCH_REG_UPD_VIEW_ALL')) {
          this.activeName = 'viewAll';
        } else if (this.permissions.includes('REG_WTCH_REG_UPD_COVID_19')) {
          this.activeName = 'covid19';
        } else if (this.permissions.includes('REG_WTCH_REG_UPD_FLAGGED')) {
          this.activeName = 'flag';
        } else if (this.permissions.includes('REG_WTCH_REG_UPD_ARCHIVE')) {
          this.activeName = 'archive';
        }
        this.selectedMenu = this.activeName;
      }
    },
    clearDataProps() {
      this.headerValues = {
        newCount: 0,
        viewAllCount: 0,
        flaggedCount: 0,
        archiveCount: 0,
        covid19Count: 0
      };
      this.regUpdatesIdList = {
        new: [],
        flag: [],
        archive: [],
        country_affected: []
      };
      this.regulatoryUpdateList = {
        viewAll: [],
        new: [],
        flag: [],
        archive: [],
        covid19: [] // covid19
      };
    },
    filterSearchRegulatory(searchRegulatory) {
      if (this.isFromGlobalSearch && this.filterInitialCounts.search) {
        this.isFromGlobalSearch = false;
        this.filterRegUpdates(this.regulatoryFilterObj);
      }
      this.filterInitialCounts = { ...this.filterInitialCounts, search: true };
      this.searchRegulatory = searchRegulatory;
    },

    setFilterOptions(filterOptions) {
      const res = {};
      res.countries = filterOptions.countriesList;
      const isEffectiveDatesSelected = this.checkIsDatesSelected(filterOptions.effectiveDates);
      const isPublishedDatesSelected = this.checkIsDatesSelected(filterOptions.dateRange);
      res.flags = {
        country: !!filterOptions.countriesList.length,
        effectiveDate: isEffectiveDatesSelected,
        publishedDate: isPublishedDatesSelected
      };
      if (isPublishedDatesSelected) {
        res.publishedDate = {
          startDate: filterOptions.dateRange.from,
          endDate: filterOptions.dateRange.to
        };
      }
      if (isEffectiveDatesSelected) {
        res.effectiveDate = {
          startDate: filterOptions.effectiveDates.from,
          endDate: filterOptions.effectiveDates.to
        };
      }
      this.regulatoryFilterObj = res;
      this.filterRegUpdates(res);
      if (this.isFromGlobalSearch && this.filterInitialCounts.filter) {
        this.isFromGlobalSearch = false;
      }
      this.filterInitialCounts = { ...this.filterInitialCounts, filter: true };
    },
    /* to filter regUpdates based on selected filters */
    filterRegUpdates(filterObject, refArr = this.regulatoryUpdatesListCopy) {
      const actualData = this.regulatoryUpdatesListCopy[this.selectedMenu];
      const appliedFilters = Object.values(filterObject.flags);
      let refernceList = cloneDeep(refArr);
      if (appliedFilters.every((value) => !value)) {
        refernceList = { ...refernceList, [this.selectedMenu]: actualData };
      } else {
        const availableTabs = Object.keys(refernceList);
        if (!this.isFromGlobalSearch) {
          availableTabs.forEach((tab) => {
            const filteredData = this.getFilteredDataForEachTab(refArr, tab, filterObject);
            refernceList[tab] = filteredData;
          });
        }
      }
      this.sortRegulatoryList(refernceList);
      this.setCountForTabs();
    },

    getFilteredDataForEachTab(refArr, tab, filterObject) {
      return refArr[tab].filter((regUpdate) => {
        const isPublishedDate = !filterObject.flags.publishedDate
          ? true
          : this.checkIsWithinTheDateRange({
              startDate: regUpdate.publishedDate || '',
              compareStartDate: filterObject.publishedDate.startDate,
              compareEndDate: filterObject.publishedDate.endDate
            });
        const isEffectiveDate = !filterObject.flags.effectiveDate
          ? true
          : this.checkIsWithinTheDateRange({
              startDate: regUpdate.effectiveDate || '',
              compareStartDate: filterObject.effectiveDate.startDate,
              compareEndDate: filterObject.effectiveDate.endDate
            });
        if (filterObject.countries.length) {
          return (
            filterObject.countries.includes(regUpdate.countryId) &&
            isPublishedDate &&
            isEffectiveDate
          );
        }
        return isPublishedDate && isEffectiveDate;
      });
    },

    /* to check the date either within specified range or not */
    checkIsWithinTheDateRange({ startDate, compareStartDate, compareEndDate }) {
      return (
        moment(startDate).format('YYYY-MM-DD') >= moment(compareStartDate).format('YYYY-MM-DD') &&
        moment(startDate).format('YYYY-MM-DD') <= moment(compareEndDate).format('YYYY-MM-DD')
      );
    },

    checkIsDatesSelected(dateRange) {
      return !!Object.values(dateRange).length;
    },

    async setGlobalSearchResultData(globalSearchData) {
      const refObj = { ...this.globalSearchFilteredData };
      globalSearchData.forEach((regUpdate) => {
        const regUpdateObj = this.createRegulatoryUpdateObject(regUpdate, this.productByCountry);
        refObj.viewAll.push(regUpdateObj);
      });
      this.globalSearchFilteredData = cloneDeep(refObj);
    },

    /* All alerts to get countries list, user-regupdates, pdt registrations */
    async getAllRegAlerts() {
      this.clearDataProps();
      await this.getCountryList();
      await this.getUserRegulatoryUpdateStatus();
      await this.getProductRegistrations();
      this.covid19KeysList = await getCOVID19Keys();
      // const publishedAlerts = await getPublishedRegulatoryAlerts();
      this.publishedAlerts = await getPublishedRegulatoryAlerts();
      const allAvailableRegUpdateIdsStatus = this.getIdsWithStatus();
      const currentList = this.setRegUpdatesData(
        this.publishedAlerts,
        allAvailableRegUpdateIdsStatus
      );
      this.regulatoryUpdatesListCopy = cloneDeep(currentList);
      this.setDataBasedOnSelectedConstraints(currentList);
    },

    getIdsWithStatus() {
      return Object.keys(this.regUpdatesIdList).reduce((acc, key) => {
        const availableIdsWithStatus = this.setIdsInObj(this.regUpdatesIdList[key]);
        acc[key] = availableIdsWithStatus;
        return acc;
      }, {});
    },

    setIdsInObj(arr) {
      return arr.reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});
    },

    setRegUpdatesData(allRegupdates, regUpdatesStatus) {
      const refObj = this.isFromGlobalSearch
        ? this.globalSearchFilteredData
        : this.regulatoryUpdateList;
      const refernceOfList = Object.keys(refObj).reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});
      allRegupdates.forEach((regUpdate) => {
        const regUpdateObj = this.createRegulatoryUpdateObject(regUpdate, this.productByCountry);
        /* For New List */
        if (regUpdatesStatus.new[regUpdate.id] && !regUpdatesStatus.archive[regUpdate.id]) {
          regUpdateObj.isNew = true;
          regUpdateObj.updateAction = 'remove';
          refernceOfList.new.push(regUpdateObj);
        }
        if (regUpdatesStatus.flag[regUpdate.id] && !regUpdatesStatus.archive[regUpdate.id]) {
          /* For flagged list */
          regUpdateObj.isFlagged = true;
          regUpdateObj.updateAction = 'archive';
          refernceOfList.flag.push(regUpdateObj);
        }
        if (regUpdatesStatus.archive[regUpdate.id]) {
          /* For Archive List */
          regUpdateObj.isArchive = true;
          regUpdateObj.updateAction = 'unarchive';
          refernceOfList.archive.push(regUpdateObj);
        }
        /* For Covid List */
        const isCovidTextPresent =
          this.covid19KeysList.some((key) =>
            regUpdateObj.title.toLowerCase().includes(key.toLowerCase())
          ) ||
          this.covid19KeysList.some((key) =>
            regUpdateObj.longDescription.toLowerCase().includes(key.toLowerCase())
          );
        if (isCovidTextPresent && !regUpdatesStatus.archive[regUpdate.id]) {
          refernceOfList.covid19.push(regUpdateObj);
        }
        /* For ViewAll */
        if (!regUpdatesStatus.archive[regUpdate.id]) {
          refernceOfList.viewAll.push(regUpdateObj);
        }
      });
      return refernceOfList;
    },

    setCountForTabs() {
      this.headerValues = {
        newCount: this.regulatoryUpdateList.new.length,
        viewAllCount: this.regulatoryUpdateList.viewAll.length,
        flaggedCount: this.regulatoryUpdateList.flag.length,
        archiveCount: this.regulatoryUpdateList.archive.length,
        covid19Count: this.regulatoryUpdateList.covid19.length
      };
    },

    /* Sort RegUpdates by publishedDate */
    sortRegulatoryList(refernceOfList) {
      Object.keys(refernceOfList).forEach((key) => {
        refernceOfList[key] = refernceOfList[key].sort((a, b) => {
          if (
            moment(a.publishedDate, 'MMM DD, YYYY').isAfter(moment(b.publishedDate, 'MMM DD, YYYY'))
          ) {
            return -1;
          }
          return moment(b.publishedDate, 'MMM DD, YYYY').isAfter(
            moment(a.publishedDate, 'MMM DD, YYYY')
          )
            ? 1
            : 0;
        });
      });
      this.regulatoryUpdateList = cloneDeep(refernceOfList);
    },

    /* For getting Ids of different categories like flag, new, archive etc */
    async getUserRegulatoryUpdateStatus() {
      const response = await getRegulatoryWatchStatus();
      if (response) {
        this.regUpdatesIdList.new = response.new || [];
        this.regUpdatesIdList.flag = response.flagged || [];
        this.regUpdatesIdList.archive = response.archived || [];
        this.regUpdatesIdList.country_affected = response.country_affected || [];
      }
    },

    createRegulatoryUpdateObject(data, productRegistrations) {
      let productObj = null;
      if (productRegistrations.length > 0) {
        const obj = productRegistrations.find((p) => p.country_id === data.country_id);
        productObj = obj && Object.keys(obj).length ? obj : null;
      }
      const longDescription = data.description;
      let shortDescription = '';
      if (longDescription.length > 215) {
        shortDescription = `${longDescription.slice(0, 215)}...`;
      }
      return {
        regUpdateId: data.id,
        productCount: productObj ? productObj.product.length : 0,
        productList: productObj ? productObj.product : [],
        countryCode: data.country_code,
        countryId: data.country_id,
        publishedDate: moment(data.published_date).format('MMM DD, YYYY'),
        countryName: data.country_name,
        linkList: data.info_link ? JSON.parse(data.info_link) : [],
        longDescription: data.description,
        shortDescription,
        title: data.title,
        isNew: false,
        isFlagged: false,
        isArchive: false,
        isViewAll: false,
        updateAction: '',
        seeLess: shortDescription.length > 0,
        effectiveDate: data.regulatory_effective_date
          ? moment(data.regulatory_effective_date).format('MMM DD, YYYY')
          : ''
      };
    },

    async getProductRegistrations() {
      const localProductByCountry = [];
      const products = await getUserProdRegistration();
      products.forEach((data) => {
        let obj = localProductByCountry.find(
          (country) => country.country_code === data.country_code
        );
        if (!obj) {
          obj = {
            country_code: data.country_code,
            product: [],
            country_name: data.country_name,
            country_id: data.country_id
          };
        }
        obj.product.push({
          name: data.productName,
          regId: data.registrationId
        });
        localProductByCountry.push(obj);
      });
      this.productByCountry = localProductByCountry;
    }
  },

  beforeDestroy() {
    EventBus.$off('updateRegWatch');
  },

  mounted() {
    this.$root.$on('regulatoryUpdatesAffected', (countryName, countryId) => {
      // from Registration Details
      if (this.permissions.includes('REG_WTCH_REG_UPD_COUNTRY_FILTER')) {
        EventBus.$emit('redirectionParams', { countryId });
      }
    });
    EventBus.$on('updateRegWatch', () => {
      this.loaderStatus = true;
      if (this.isFromGlobalSearch) {
        this.isFromGlobalSearch = false;
      }
      this.getAllRegAlerts();
      this.loaderStatus = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.p-relative {
  position: relative;
}

.reg-update-tabs {
  margin-left: 85px;
  width: calc(100% - 90px);
}
</style>
